import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import React from 'react'

function PrintReport(props) {
    const columns = Object.entries(props.headers || {});
    if (columns.length < 4) columns.length = 4
    const numberOfColumns = Math.floor(columns?.length / 4);
    const dataToRender = new Array(Math.ceil(columns?.length / numberOfColumns))
        .fill().map(_ => columns.splice(0, 4))
        .filter((arr) => arr.length !== 0);

    const columnHeader = (data) => {
        return data?.map((column, index) => {
            return <TableCell key={index} className='col-width table-cell-border'>{column.length > 0 && column[0]?.toUpperCase()}</TableCell>
        })
    }

    const columnData = (data) => {
        return data?.map((row, index) => {
            return <TableCell key={index} className='col-width table-cell-border'>{row.length > 0 && row[1]}</TableCell>
        })
    }

    return (
        <>
            <div className='margin-bottom-8'>
                {
                    dataToRender?.map((data, index) => {
                        return <TableContainer component={Paper} key={index}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {data.length > 0 && columnHeader(data)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        {data.length > 0 && columnData(data)}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    })
                }
            </div>
        </>
    )
}

export default PrintReport